//@ts-check
import React, { useEffect, useState } from "react"
import Button from "@material-ui/core/Button"
import ListIcon from "@material-ui/icons/List"
import TextFieldsIcon from "@material-ui/icons/TextFields"
import ParameterInput from "./parameter-input"
import { Select } from "./select"
import CONSTS from "shared/consts"
import store from "../store"
import { invalidColor } from "../validations"
/**
 * @param props {{
 * label,
 * onChange(value:any):void
 * type,
 * value,
 * components?:[],
 * list?:any[]
 * optional?:boolean,
 * wrapperStyling?:any
 * disabled?:boolean
 * hint?:string
 * valid?: boolean
 * hideType?: boolean
 * autofocus?: boolean
 * onBlur?: Function
 * }}
 */
export default function ValueOrChoose({
  label,
  autofocus=false,
  onBlur,
  labelBackground,
  // valueOrChoose,
  // setValueOfChoose,
  type,
  valid,
  value,
  hideType,
  optional=false,
  components,
  onChange,
  list = [],
  wrapperStyling,
  disabled,
  hint = "",
}) {
  var valueProp=value
  var [internalValue,set_internalValue]=useState(value)
  var value=internalValue

  useEffect(()=>{
    set_internalValue(valueProp)
  },[valueProp])

  
  if (type == "address") {
    list = [
      "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
      "0xbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb",
      "0xcccccccccccccccccccccccccccccccccccccccc",
      ...list]
  }

  var steps=store.steps



  const stepNumber = steps.findIndex(item => item === value)
  steps = steps.slice(0, stepNumber)
  if (type == "bytes" || type == "string") {
    steps.forEach(s => {
      if (s.type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION) {
        if (s.alias) {
          list.push(s.alias)
        }
      }
      if (s.type == CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT) {
        if (s.alias) {
          list.push(s.alias)
        }
      }
    })
  }
  if (type == "address") {
    steps.forEach(s => {
      if (s.type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION) {
        if (s.alias) {
          list.push(s.alias)
        }
      }
      if (s.type == CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT) {
        if (s.alias) {
          list.push(s.deployAlias)
        }
      }
    })
  }
  // }
    
  return (
    <div style={{
      // background:valid===false ? invalidColor : undefined,
      ...(wrapperStyling || {}),
      border:valid===false ? '1px solid ' + invalidColor : undefined
    }}>
      
      <div css={`
        display: flex;
        flex-direction: row;          
      `}>
        <ParameterInput
          width="100%"
          wrapperWidth="100%"
          type={type}
          components={components}
          hideType={hideType}
          optional
          value={value}
          onChange={e => {
            if(e){
              set_internalValue(e.target.value)
              onChange(e.target.value)
            }
          }}
          label={label}
          hint={hint}
          disabled={disabled}
          labelBackground="white"
          autofocus={autofocus}
          onBlur={onBlur}
        />          
      </div>
    </div>
  )
}
